<template>
    <div>
        <!--聊天记录部分-->
        <div class="topMessage" v-loading="dataLoading">
            <div class="topMore" v-if="messageTotal>messageList.length">
                <div class="topMoreBtn" @click="moreClick">获取更多记录</div>
            </div>
            <div class="messageAuto">
                <div class="messageList" v-for="(item,index) in messageList" :key="index">
                    <!--专家的消息-->
                    <div class="messageListT" v-if="item.sendId == teacherInfo.userId">
                        <div class="mListHeaderT">
                            <img :src="imgObj.img_header" alt="">
                        </div>
                        <div class="mListTextName">{{ item.userName }}</div>
                        <div class="mListTextT">
                            <span class="mListTextTC">{{ item.message }}</span>
                        </div>
                    </div>
                    <!--用户的消息-->
                    <div class="messageListU" v-else>
                        <div class="mListHeaderU">
                            <div class="">
                                <img :src="imgObj.img_header_user" alt="">
                            </div>
                        </div>
                        <div class="mListTextU">
                            <div class="mListTextUC">{{ item.message }}</div>
                        </div>
                    </div>
                    <div class="messageListTime">{{ item.createTime }}</div>
                </div>
            </div>
        </div>
        <!--消息发送部分-->
        <div class="inputDom">
            <div class="inputTop">
                <div class="textareaBox">
                    <el-input
                        type="textarea"
                        :maxlength=100
                        placeholder="请输入您想咨询的问题~"
                        v-model="userInput">
                    </el-input>
                </div>
            </div>
            <div class="inputBottom">
                <div class="askSubmit" v-loading="sendMessageLoading" @click="sendMessageBtn">提问</div>
            </div>
        </div>
    </div>
</template>
<script>

let VUEThis = null;

//引入图片
import img_header from '@/assets/images/swjcw/header.png'
import img_header_user from '@/assets/images/swjcw/header_user.png'


//引入接口
import { getUserSig,getMessageData,getSendMSG } from '@/api/askApi.js'

export default {
    name:"chat",
    props:['sendData'],
    data(){
        return{
            imgObj:{
                img_header,
                img_header_user
            },
            TIM,
            tim,
            dataLoading:false,
            sendMessageLoading:false,
            websock:null,
            //签名
            userSig:'',
            //当前使用用户
            userInfo:{},
            userId:'',
            //默认文字
            hellowText:'您好，感谢您的咨询。我是中税答疑特聘专家，您可以将您的问题输入至下方对话框并发送给我。我们将在15分钟内响应，2小时内专家介入，6小时内提供对应方案，辛苦您耐心等待。',
            hellowTimer:null,
            //专家信息
            teacherInfo:{

            },
            tPage:1,
            tSize:10,
            //消息列表
            messageList:[],
            messageTotal:0,
            //用户提问的关键字
            userInput:'',
            //本地存储最近一条消息
            thatMsgObj:{},
        }
    },
    created(){
        VUEThis = this;
        //获取用户信息
        let tSession = sessionStorage.getItem("userInfoData");
        this.userInfo = JSON.parse(tSession);
        this.userId = this.userInfo.id;
        //获取专家信息
        this.teacherInfo = this.$props.sendData;
        console.log(this.teacherInfo)
    },
    mounted(){
        //初始化websocket
        this.initWebSocket();
        //获取签名
        this.getUserSigData();
        //获取消息列表
        this.getMessageList('start');
    },
    destroyed(){
        clearInterval(this.hellowTimer);
        //生命周期结束断开
        this.websocketclose()
        this.websock.close()
        this.websock.onclose()
    },
    methods:{
        //获取签名
        getUserSigData(){
            let sendData = {
                id:'U' + this.userId,
            }
            getUserSig(sendData).then(res => {
                if(res.status == 200&&res.data.status ==0){
                    //获取到签名
                    this.userSig = res.data.data
                    //初始化tim聊天
                    this.initListener();
                }
            }).catch(err =>{
                console.log(err)
            })
        },
        //初始化websocket
        initWebSocket(){
            if (typeof WebSocket === "undefined") return alert("您的浏览器不支持WebSocket")

            //暂时写死的地址
            const apiLink = 'zsdy-just-ask-frontend-api.shui12366.com/websocket/'
            // websocket地址
            const wsuri = `wss://` + apiLink + this.userId;
            // 初始化socket方法
            this.websock = new WebSocket(wsuri);
            // 连接成功的处理
            this.websock.onopen = this.websocketonopen;
            // 接收数据之后的处理
            this.websock.onmessage = this.websocketonmessage;
            // 报错的处理
            this.websock.onerror = this.websocketonerror;
            // 关闭连接的处理
            this.websock.onclose = this.websocketclose;
        },
        //scoket连接成功
        websocketonopen(){
            console.log('scoket已连接')
            const self = this
            self.timer = setInterval(() => {
                try {
                    const jsonHeart = {
                    status: 'heart', // 向服务端标明 本机心跳
                    msg: '心跳' // 同时携带登录用户信息
                    }
                    self.websock.send(JSON.stringify(jsonHeart)) // 发送消息
                    if(self.websock.readyState !== 1){
                        clearInterval(self.timer)
                        //self.initWebSocket()
                    }
                    // console.log(self.websock.readyState,123)
                } catch (err) {
                    self.connection()
                }
            }, 5000) // 定时发送
        },
        //接收后端返回的数据
        websocketonmessage: async function (e) {
            console.log(e)
            let jsonSuccess = this.parseJSONCapture(e.data)
            //console.log(typeof jsonSuccess == 'object')
            if(typeof jsonSuccess == 'object'){
                if(jsonSuccess.msg&&jsonSuccess.msg.indexOf("超过30分钟")!=-1){
                    //this.openDialog = true;
                    let that = this;
                    // this.$message({
                    //     message:jsonSuccess.msg,
                    //     customClass:'timerMes',
                    //     dangerouslyUseHTMLString:true,
                    //     duration:150000,
                    //     showClose: true,
                    // })
                    setTimeout(function(){
                        //that.openDialog = false
                    },4000)
                }
            }
        },
        //scoket连接失败
        websocketonerror(e){
            console.log('scoket失败')
            console.log(e)
            //尝试重新连接
            //this.initWebSocket();
        },
        //关闭socket链接
        websocketclose(e){
            console.log('断开连接' + e)
            console.log(e)
            this.websock.close()
        },
        //parse方法
        parseJSONCapture(str) {
            try {
                return JSON.parse(str);
            }
            catch (e) {
                console.log(e);
                //返回默认对象，或根据用例返回。
                return str
            }
        },

        
        //初始化tim聊天
        initListener(){
            let that = this;
            let promise = that.tim.login({
                userID: 'U' + that.userId,
                userSig:that.userSig
            })
            promise.then(function (imResponse) {
                //初始化成功
                console.log('初始化成功',imResponse)
                if(imResponse.data.errorInfo==''){
                    that.watchTim()
                }
            }).catch(function (imError) {
                console.log("初始化失败",imError)
            })
        },
        //监听函数
        watchTim(){
            this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage)
        },
        // 获取最新消息 (腾讯云)
        onReceiveMessage (event) {
            let that= this
            //刷新获取用户列表
            //this.getUserList()
            console.log(event)
            //let  num = this.messageList.length
            //this.messageList = this.messageList.slice(0,--num)
            // let domScroll = document.getElementsByClassName('messageShowBox')
            // if(domScroll.length!=0){
            //     domScroll[0].scrollTop -=1
            // }
            debugger
            VUEThis.tPage=1;
            VUEThis.getMessageList();
            //获取到新消息 就存储缓存 显示红点
            // let newObj = {
            //     isNeedRed:true,
            // }
            // sessionStorage.setItem("isNeedRedSession",JSON.stringify(newObj));
        },
        //获取消息列表
        getMessageList(type){
            let that = this;
            let send_data = {
                pageNo: this.tPage,
                pageSize: this.tSize,
                userId:this.teacherInfo.userId
            };
            this.dataLoading = true;
            getMessageData(send_data).then(res => {
                if(res.status == 200&&res.data.status ==0){
                    that.messageTotal = res.data.total;
                    //console.log(res.data.rows)
                    if(type=='fenye'){
                        that.messageList = res.data.rows.reverse().concat(that.messageList);
                        that.dataLoading = false;
                    }else{
                        that.messageList = res.data.rows.reverse();

                        //如果是0条的话
                        // if(that.messageTotal == 0){
                        //     let newObj = {
                        //         message:this.hellowText,
                        //         sendId: that.teacherInfo.userId
                        //     }
                        //     that.messageList.push(newObj)
                        // }

                        //是否是开始进入的
                        if(type == 'start'){
                            let newObj = {
                                message:'',
                                sendId: that.teacherInfo.userId,
                                ttId:'add'
                            }
                            that.messageList.push(newObj)
                            that.textAddFn()
                        }
                        //定位到最下面
                        that.$nextTick(function(){
                            setTimeout(() => {
                                let autoView = document.getElementsByClassName('messageAuto')[0];
                                autoView.scrollTop = autoView.scrollHeight;
                                that.dataLoading = false;
                            },200)
                            //console.log(autoView)
                        })
                    }
                }
            }).catch(err => {
                console.log(err)
                this.dataLoading = false;
            })
        },
        textAddFn(){
            //遍历 找到
            this.messageList.forEach((item) => {
                if(item.ttId&&item.ttId=='add'){
                    clearInterval(this.hellowTimer);
                    let tIndex = 0;
                    let newText = '';
                    this.hellowTimer = setInterval(() => {
                        tIndex ++ 
                        newText = this.hellowText.substring(0,tIndex);
                        item.message = newText;
                        if(newText == this.hellowText){
                            clearInterval(this.hellowTimer);
                            //console.log('关闭了')
                        }
                    },20)
                }
            })
        },
        //点击提问按钮
        sendMessageBtn(){
            if(this.userInput === ''){
                this.$message('请输入您想咨询的问题~');
                return
            }
            //判断当前专家是正在沟通的专家么
            if(this.teacherInfo.dialogueTeacherId&&this.teacherInfo.dialogueTeacherId!=''){
                if(this.teacherInfo.userId == this.teacherInfo.dialogueTeacherId){
                    this.sendMessageZSDY('')
                }else{
                    this.$message('您有正在咨询中的专家，需要结束此次服务后再咨询其他专家')
                }
            }else{
                this.sendMessageZSDY('')
            }
        },
        //发送消息到服务器(zsdy)
        sendMessageZSDY(type){
            this.sendMessageLoading = true;
            //传递给zsdy接口的参数
            let data = {
                acceptId:this.teacherInfo.userId,
                message:this.userInput,
                sendId:this.userId,
            }
            //是否是结束服务
            if(type&&type=='over'){
                data.type = 1;
                data.message = '结束服务'
            }
            //最保存最近的消息内容
            this.thatMsgObj = {
                type: "0",
                acceptId:this.teacherInfo.userId,
                message:this.userInput,
                sendId:this.userId
            }
            getSendMSG(data).then(res =>{
                //console.log(res)
                if(type&&type=='over'){
                    this.$emit('emitOver',{status:false})
                }else{
                    this.$emit('emitOver',{status:true})
                }
                //定位到最下面
                VUEThis.$nextTick(function(){
                    setTimeout(() => {
                        let autoView = document.getElementsByClassName('messageAuto')[0];
                        autoView.scrollTop = autoView.scrollHeight;
                    },200)
                })
                //发消息到腾讯云
                this.getSendMessage(type)
                this.sendMessageLoading = false;
            }).catch( err => {
                console.log(err)
                this.sendMessageLoading = false;
            })
        },
        //发送消息 (腾讯云)
        getSendMessage(tType){
            // console.log(VUEThis.teacherInfo.userId)
            // console.log(VUEThis.TIM.TYPES.CONV_C2C)
            // console.log(VUEThis.userInput)
            let that = this
            // 1. 创建消息实例，
            let message = VUEThis.tim.createTextMessage({
                to: "S"+VUEThis.teacherInfo.userId,
                conversationType: VUEThis.TIM.TYPES.CONV_C2C,
                payload: {
                    text: tType=='over'?'结束服务':VUEThis.userInput
                },
            });
            // 2. 发送消息
            let promise = that.tim.sendMessage(message);
            promise.then(function(imResponse) {
                // 发送成功
                console.log(imResponse);
                //判断是否是结束服务
                if(tType&&tType=='over'){
                    //重新获取一下消息列表
                    that.getMessageList();
                }else{
                    that.messageList.push(that.thatMsgObj);
                    // that.$nextTick(function(){
                    //     let domScroll = document.getElementsByClassName('messageShowBox')
                    //     if(domScroll.length!=0){
                    //         domScroll[0].scrollTop = 99999
                    //     }
                    // })
                }
                //重置输入框
                VUEThis.userInput = '';
                //回调给上一个页面
                //that.emitParent();
                //that.getSendMsgZSDY(that.toId,that.userInfo.id,that.sendMsg)
            }).catch(function(imError) {
                // 发送失败
                console.warn('sendMessage error:', imError);
                // uni.showToast({
                //     title:"专家未完成通讯注册~",
                //     icon: 'none'
                // })
                // 敏感词汇
                if (imError.code === 80001 ) {
                    let reg = new RegExp(/(:.*(?=\|))/, 'g')
                    let str = reg.exec(imError.message)
                    console.log(str)
                    uni.showToast({
                        title: '消息中包含敏感词汇' + str[0],
                        icon: 'none',
                        duration: 3000
                    })
                }
                //that.DelMessage(MsgContent.id)
                //回调给上一个页面
                //that.emitParent(2)
            });
        },
        //点击获取更多
        moreClick(){
            this.tPage +=1;
            this.getMessageList('fenye')
        },
        //结束服务
        overNowDialogue(){
            //this.$message('结束服务')
            this.sendMessageZSDY('over')
        }

    }
}
</script>

<style lang="scss" scoped>
.topMessage{
    width:100%;
    height:422px; 
    border-bottom:2px solid #D8D8D8;
    box-sizing: border-box;
    padding:20px 18px 20px 20px;
    position: relative;
    .topMore{
        width:100%;
        height:28px;
        margin:0 auto;
        line-height: 28px;
        font-size: 15px;
        position: absolute;
        top:0;
        left:0;
        text-align: center;
        .topMoreBtn{
            width:100px;
            height:28px;
            margin:0 auto;
            cursor:pointer;
        }
    }
    .messageAuto{
        width:100%;
        height:380px;
        overflow-y: auto;
        box-sizing: border-box;
        padding-bottom:10px;
        .messageList{
            width:100%;
            margin-bottom:15px;
            .messageListTime{
                text-align: center;
            }
            .messageListT{
                width:100%;
                min-height: 81px;
                position: relative;
                .mListHeaderT{
                    width:60px;
                    height:60px;
                    border-radius: 50%;
                    display: inline-block;
                    background: #D8D8D8;
                    img{
                        width:100%;
                    }
                }
                .mListTextName{
                    width:calc(100% - 140px);
                    height:22px;
                    box-sizing: border-box;
                    padding-left:10px;
                    display: inline-block;
                    position: absolute;
                    top:0;
                }
                .mListTextT{
                    width:calc(100% - 140px);
                    box-sizing: border-box;
                    padding-left:10px;
                    display: inline-block;
                    .mListTextTC{
                        display: inline-block;
                        background: #EEF8FF;
                        padding:15px 20px;
                        line-height: 24px;
                        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                        border-radius: 2px 8px 8px 8px;
                    }
                }

            }
            .messageListU{
                width:100%;
                min-height: 81px;
                box-sizing: border-box;
                padding:0 0px 2px 0;
                overflow: hidden;
                .mListTextU{
                    float:right;
                    max-width:calc(100% - 140px);
                    margin-right:10px;
                    margin-top:22px;
                    .mListTextUC{
                        display: inline-block;
                        background: #EEF8FF;
                        padding:15px 20px;
                        line-height: 24px;
                        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                        border-radius: 2px 8px 8px 8px;
                    }
                }
                .mListHeaderU{
                    width:60px;
                    height:60px;
                    border-radius: 50%;
                    float:right;
                    img{
                        width:100%;
                    }
                }
            }
        }
    }
}
.inputDom{
    width:100%;
    height:235px;
    .inputTop{
        width:100%;
        height:170px;
        box-sizing: border-box;
        padding:20px;
        .textareaBox{
            width:100%;
            height:140px;
            overflow: hidden;
            ::v-deep .el-textarea >.el-textarea__inner{
                height:140px!important;
                border: 0px solid #DCDFE6!important;
            }
        }
    }
    .inputBottom{
        width:100%;
        height:65px;
        .askSubmit{
            width: 100px;
            height: 45px;
            line-height: 45px;
            text-align: center;
            background: linear-gradient( 270deg, #0F59A4 0%, #0F59A4 100%);
            box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
            float:right;
            margin-right:20px;
            box-sizing: border-box;
            font-weight: 700;
            font-size: 18px;
            color: #FFFFFF;
            letter-spacing: 9px;
            padding-left:9px;
            cursor:pointer;
        }
    }
}
</style>